<template>
  <div>
    <auth-header />
    <div class="auth-wrapper auth-v1 px-2">
      <div class="position-relative">
        <!-- <div
          class="bg-out-auth position-absolute top-0 left-0 w-100 h-100"
        ></div> -->
        <b-card class="mb-0 position-relative overflow-hidden" no-body>
          <b-card-body style="z-index: 10">
            <b-link class="brand-logo my-3">
              <div class="d-flex align-items-center justify-content-center">
                <div style="height: 24px" class="ml-50 position-relative">
                  <div class="rounded logo-shadow position-absolute"></div>

                  <b-img
                    style="max-height: 24px"
                    :src="require('@/assets/images/fxlegends/logo2.png')"
                    fluid
                    alt="FX Legends"
                  />
                </div>
              </div>
            </b-link>

            <!-- <h2 class="mb-1">Welcome! 👋</h2> -->
            <b-card-text class="mb-2 h5">
              Please sign-in to your account and start the adventure
            </b-card-text>
            <div class="w-100 d-flex">
              <router-link
                tag="button"
                :class="[
                  'w-100 mr-25 btn py-1',
                  $route.path.includes('partner')
                    ? ' select-btn'
                    : 'unselect-btn border-secondary',
                ]"
                :to="{ name: 'auth-partner-login' }"
              >
                <span> I am a Partner </span>
              </router-link>

              <router-link
                tag="button"
                :class="[
                  'w-100 ml-25 py-1 btn',
                  $route.path.includes('user')
                    ? ' select-btn'
                    : 'unselect-btn border-secondary',
                ]"
                :to="{ name: 'auth-user-login' }"
              >
                <span> I am a User </span>
              </router-link>
            </div>

            <!-- form -->
            <router-view />

            <b-card-text class="text-center mt-2">
              <span>New on our platform? </span>
              <a
                v-if="$route.path.includes('partner')"
                href="https://fxlegends.com/partner-register"
              >
                <span>Create an account</span>
              </a>
              <b-link
                v-if="$route.path.includes('user')"
                :to="{ name: 'auth-user-register' }"
              >
                <span>Create an account</span>
              </b-link>
            </b-card-text>
          </b-card-body>
          <!-- <div
            class="bg-in-auth position-absolute top-0 left-0 w-100 h-100"
          ></div> -->
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BButton,
  BButtonGroup,
  BCard,
  BCardBody,
  BLink,
  BCardTitle,
  BCardText,
  BFormCheckbox,
  BImg,
} from "bootstrap-vue";
import Logo from "@core/layouts/components/Logo.vue";
import Ripple from "vue-ripple-directive";
import AuthHeader from "../auth-header/AuthHeader.vue";
export default {
  components: {
    // BSV
    BButton,
    BButtonGroup,
    BCard,
    BCardBody,
    BCardTitle,
    BLink,
    Logo,
    BCardText,
    BFormCheckbox,
    BImg,
    AuthHeader,
  },
  directives: {
    Ripple,
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
